import { eur, fileUrl } from "@/lib/api";

export function ContractSummary({ appt }) {
  const t = appt.totals;
  return (
    <div className="rounded-2xl bg-white border border-[var(--border)] p-5 sm:p-6 space-y-5" data-testid="contract-summary">
      <div className="flex flex-wrap justify-between gap-2">
        <h2 className="font-heading text-xl font-semibold">Riepilogo preventivo</h2>
        <p className="text-sm text-[var(--muted)]">{new Date(appt.date + "T00:00").toLocaleDateString("it-IT")} {appt.time}</p>
      </div>
      <ul className="divide-y divide-[var(--border)]">
        {appt.items.map((it, i) => (
          <li key={it.id} className="flex gap-3 py-3" data-testid={`summary-item-${i}`}>
            <div className="h-16 w-16 rounded-lg bg-[var(--surface-2)] overflow-hidden shrink-0">
              {it.photo_path && <img src={fileUrl(it.photo_path)} alt="" className="h-full w-full object-cover" />}
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-medium truncate">{it.name || "Oggetto"}</p>
              <p className="text-xs text-[var(--muted)] line-clamp-2 whitespace-pre-line">{it.notes}</p>
            </div>
            <p className="font-mono font-semibold">{eur(it.price)}</p>
          </li>
        ))}
      </ul>
      <div className="rounded-xl bg-[var(--surface-2)] p-4 space-y-2 text-sm">
        <div className="flex justify-between"><span>Totale oggetti in vendita</span><span className="font-mono font-semibold" data-testid="summary-items-total">{eur(t.items_total)}</span></div>
        <div className="flex justify-between text-emerald-700 font-semibold"><span>Quota al cliente ({t.client_percentage}%)</span><span className="font-mono" data-testid="summary-client-share">{eur(t.client_share)}</span></div>
        <div className="flex justify-between text-[var(--muted)]"><span>Spese di trasporto (a parte)</span><span className="font-mono" data-testid="summary-transport">{eur(t.transport_cost)}</span></div>
      </div>
    </div>
  );
}
